import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentMethod } from 'frames-react';
import CardDetailsForm, { FlowType } from './CardDetailsForm';
import { PortfolioBalanceIcon } from '../../../../assets/icons';
import { formatterGbp } from '../../../../utils';

interface CheckoutOtpProps {
  amount: number;
  portfolioId: number;
  btnText?: string;
  flowType?: FlowType;
  onSuccessUrl?: string;
  onFailureUrl?: string;
  isUseExistingCard?: boolean;
  transactionType?: string;
  showTopUpIcon?: boolean;
  additionalPaymentMethods?: PaymentMethod[];
  cardsOnFileConfig?: { showOnlyMitEnabled: boolean };
  isProcessingPayment?: Dispatch<SetStateAction<boolean>>;
}

export const CheckoutOtp: FC<CheckoutOtpProps> = ({
  amount,
  portfolioId,
  btnText,
  flowType = FlowType.TOP_UP,
  onSuccessUrl,
  onFailureUrl,
  isUseExistingCard,
  transactionType = '',
  showTopUpIcon = true,
}) => {
  const { t } = useTranslation();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    setIsReady(true);
  }, []);
  return (
    <div className="bg-white dark:bg-slate-900">
      {flowType === FlowType.TOP_UP && showTopUpIcon && (
        <div className="p-4">
          <div className="bg-gradient-to-br from-gray-50 to-gray-100/80 dark:from-slate-800 dark:to-slate-800/50 rounded-xl p-4 border border-gray-100 dark:border-slate-700/50 shadow-sm dark:shadow-slate-950/30">
            <div className="flex items-center flex-col gap-2">
              <div className="w-10 h-10 rounded-full bg-orange/10 dark:bg-teal-500/15 flex items-center justify-center">
                <PortfolioBalanceIcon className="w-5 h-5 text-orange dark:text-teal-400" />
              </div>
              <span className="text-xs text-gray-500 dark:text-slate-400 uppercase tracking-wide">
                {t('account:slideout.topup.top_up_amount')}
              </span>
              <span className="text-xl font-semibold text-gray-900 dark:text-white">{`${formatterGbp.format(
                amount,
              )}`}</span>
            </div>
          </div>
        </div>
      )}
      {isReady && (
        <CardDetailsForm
          isUseExistingCard={isUseExistingCard}
          btnText={btnText}
          ContainerClassName="flex"
          amount={amount}
          flow={flowType}
          transactionType={transactionType}
          portfolioId={portfolioId}
          onSuccessUrl={onSuccessUrl}
          onFailureUrl={onFailureUrl}
        />
      )}
    </div>
  );
};
